/** Renders a 'flight line' (service detail) */
import React from 'react';
import { Map, List } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import moment from 'moment';
import classnames from 'classnames';
import { airportNameLocByIata } from '../airport/airportUtils';
import { countStops } from './filters/stops/stops';

const Flight = ({ serviceDetail = Map(), airportByIata = Map() }) => {
  // TODO: Plug in airport service, this is a hack
  const fromUri = serviceDetail.get('from', '');
  const fromIata = fromUri.substring(fromUri.length - 3);
  const toUri = serviceDetail.get('to', '');
  const toIata = toUri.substring(toUri.length - 3);
  const mCommence = moment(serviceDetail.get('commence'));
  const mComplete = moment(serviceDetail.get('complete'));
  const duration = moment.duration(serviceDetail.get('duration'));
  const stopCount = countStops(serviceDetail);
  const stops = serviceDetail
    .get('via', List())
    .reduce((l, via) => l.push(via.substring(via.length - 3)), new List())
    .join(', ');

  const sameDay = mCommence.isSame(mComplete, 'day');
  return (
    <div
      className={classnames({
        'flight-col': true,
        'col-sm-12': true,
        'col-lg-13': true,
        'has-stops': stopCount > 0,
      })}
    >
      <div className='col-wrapper-va'>
        <div className='v-align'>
          <dl className='flight-from-to'>
            {stopCount > 0 && (
              <span className="stops">
                {/* TODO: Stop locations*/}
                <i title='This flight has stops'></i>
              </span>
            )}
            <dt title={airportNameLocByIata(fromIata, airportByIata)}>
              <time>
                {mCommence.format('HH:mm')}
                {/* TODO: Compact results display using: <span className="more-opts" title="3 other alternative departure times exist for the same price"/> */}
              </time>
              <div className='iata'>{fromIata}</div>
            </dt>
            <dd title={airportNameLocByIata(toIata, airportByIata)}>
              <div className='iata'>{toIata}</div>
              <time>
                {mComplete.format('HH:mm')}
                {sameDay ? '' : <sup>+{mComplete.diff(mCommence, 'days') > 0 ? mComplete.diff(mCommence, 'days') : `1`}d</sup>}
              </time>
            </dd>
          </dl>
          <dl className='flight-duration'>
            <dt className='date'>
              {mCommence.format('D MMM')}
              {sameDay ? '' : ` - ${mComplete.format('D MMM')}`}
            </dt>
            <dt>
              {Math.floor(duration.asHours())}h{duration.minutes() ? ` ${duration.minutes()}m` : ''}
            </dt>
            {stopCount > 0 && (
              <dd>
                {stopCount} stop{stopCount !== 1 ? 's' : ''} <span className='stop-locations'> {`(${stops})`}</span>
              </dd>
            )}
          </dl>
        </div>
      </div>
    </div>
  );
};

Flight.propTypes = {
  /** ServiceDetail of flight to render */
  serviceDetail: ImmutablePropTypes.map.isRequired,

  /** Map<IataCode,AirportDetail> to look up airport information in */
  airportByIata: ImmutablePropTypes.map,
};

export default Flight;



// WEBPACK FOOTER //
// ./src/ndc/offer/Flight.js